// BHPNPP-3021: Roster Management REST calls. These hit provider-be REST endpoints (multipart
// upload + presigned template URL) with the Okta bearer token — the same pattern as
// client-report submission (see client/domain/client-report.tsx), not GraphQL.

const API_BASE = `${process.env.REACT_APP_API_URL}/api`;

export const ROSTER_UPLOAD_API_URL = `${API_BASE}/portal/roster-upload`;
export const ROSTER_TEMPLATE_API_URL = `${API_BASE}/portal/roster-template`;

// Sparkle case-create is synchronous and normally takes 10-20s; the modal locks its close
// controls while submitting, so a hung request must abort rather than trap the user.
const UPLOAD_TIMEOUT_MS = 60_000;

/** Multipart POST of the (AV-scanned) roster file. Resolves with the raw Response so the caller
 *  can branch on status — failures must surface in the modal, never as a persisted history row.
 *  Rejects with a DOMException named 'AbortError' after 60s (nothing else aborts this signal). */
export function uploadRosterFile(file: File, token?: string): Promise<Response> {
    const formData = new FormData();
    formData.append('file', file);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), UPLOAD_TIMEOUT_MS);
    return fetch(ROSTER_UPLOAD_API_URL, {
        method: 'POST',
        headers: {Authorization: token ? `Bearer ${token}` : ''},
        body: formData,
        signal: controller.signal,
    }).finally(() => clearTimeout(timer));
}

/** Fetches the presigned S3 URL for the canonical roster template. */
export async function fetchRosterTemplateUrl(token?: string): Promise<string> {
    const response = await fetch(ROSTER_TEMPLATE_API_URL, {
        headers: {Authorization: token ? `Bearer ${token}` : ''},
    });
    if (!response.ok) {
        throw new Error(`Template request failed with status ${response.status}`);
    }
    const {url} = await response.json();
    return url;
}
